import { render, staticRenderFns } from "./valmistumispyynnot-card.vue?vue&type=template&id=6db34422&scoped=true&"
import script from "./valmistumispyynnot-card.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnot-card.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnot-card.vue?vue&type=style&index=0&id=6db34422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db34422",
  null
  
)

export default component.exports